/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiEmailDtoDmarcRecord
 */
export interface WebApiEmailDtoDmarcRecord {
    /**
     * 
     * @type {string}
     * @memberof WebApiEmailDtoDmarcRecord
     */
    type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiEmailDtoDmarcRecord
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiEmailDtoDmarcRecord
     */
    hostName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiEmailDtoDmarcRecord
     */
    status?: boolean;
}

/**
 * Check if a given object implements the WebApiEmailDtoDmarcRecord interface.
 */
export function instanceOfWebApiEmailDtoDmarcRecord(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiEmailDtoDmarcRecordFromJSON(json: any): WebApiEmailDtoDmarcRecord {
    return WebApiEmailDtoDmarcRecordFromJSONTyped(json, false);
}

export function WebApiEmailDtoDmarcRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiEmailDtoDmarcRecord {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'hostName': !exists(json, 'host_name') ? undefined : json['host_name'],
        'status': !exists(json, 'status') ? undefined : json['status'],
    };
}

export function WebApiEmailDtoDmarcRecordToJSON(value?: WebApiEmailDtoDmarcRecord | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'value': value.value,
        'host_name': value.hostName,
        'status': value.status,
    };
}

